var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 161.2 48.2",
    style: {
      enableBackground: "new 0 0 161.2 48.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BCBCBB;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.2;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:url(#SVGID_2_);}\n\t.st5{fill:url(#SVGID_3_);}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{opacity:0.2;fill:#020203;enable-background:new    ;}\n\t.st8{opacity:0.12;fill:#020203;enable-background:new    ;}\n\t.st9{opacity:0.25;fill:#FFFFFF;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.3,48.2l-138.7,0c-0.4,0-0.7,0-1.1,0c-0.7,0-1.6-0.1-2.5-0.2c-0.9-0.2-1.7-0.4-2.4-0.8 c-0.8-0.4-1.5-0.9-2.1-1.5c-0.6-0.6-1.1-1.3-1.5-2c-0.4-0.7-0.6-1.5-0.8-2.4C0.1,40.3,0,39.4,0,38.8c0-0.2,0-0.5,0-0.7l0-1.6l0-26.2 c0-0.2,0-0.5,0-0.7C0,8.8,0.1,7.9,0.2,7C0.4,6.1,0.7,5.3,1,4.6c0.4-0.8,0.9-1.5,1.5-2.1C3.2,1.9,3.9,1.4,4.6,1 C5.4,0.6,6.2,0.4,7,0.2C7.9,0.1,8.8,0,9.5,0l2.4,0l138.7,0l1.1,0c0.7,0,1.6,0.1,2.5,0.2c0.9,0.2,1.7,0.4,2.4,0.8 c0.8,0.4,1.5,0.9,2.1,1.5c0.6,0.6,1.1,1.3,1.5,2.1c0.4,0.8,0.6,1.5,0.8,2.4c0.2,0.8,0.2,1.6,0.2,2.4c0,0.4,0,0.7,0,1.1 c0,0.4,0,0.9,0,1.3v24.6c0,0.4,0,0.9,0,1.3c0,0.4,0,0.7,0,1.1c0,0.8-0.1,1.6-0.2,2.5c-0.1,0.9-0.4,1.6-0.8,2.4 c-0.4,0.8-0.9,1.5-1.5,2.1c-0.6,0.6-1.3,1.1-2.1,1.5c-0.7,0.4-1.5,0.6-2.4,0.8c-0.9,0.2-1.7,0.2-2.5,0.2c-0.4,0-0.7,0-1.1,0 L149.3,48.2z M11.9,1.2l-2.4,0c-0.6,0-1.5,0.1-2.3,0.2C6.5,1.5,5.8,1.8,5.2,2.1C4.5,2.4,3.9,2.9,3.4,3.4c-0.5,0.5-1,1.1-1.3,1.8 C1.8,5.8,1.6,6.4,1.4,7.2C1.3,8,1.2,8.8,1.2,9.5c0,0.2,0,0.5,0,0.7l0,1.6l0,26.2c0,0.2,0,0.5,0,0.7c0,0.6,0.1,1.5,0.2,2.3 c0.1,0.8,0.4,1.4,0.7,2.1c0.3,0.7,0.8,1.2,1.3,1.7c0.5,0.5,1.1,1,1.8,1.3c0.6,0.3,1.3,0.5,2.1,0.7C8,46.9,8.9,47,9.5,47 c0.4,0,0.7,0,1.1,0l1.3,0l138.7,0c0.4,0,0.7,0,1.1,0c0.7,0,1.5-0.1,2.3-0.2c0.8-0.1,1.5-0.4,2.1-0.7c0.7-0.3,1.2-0.8,1.8-1.3 c0.5-0.5,0.9-1.1,1.3-1.8c0.3-0.6,0.5-1.3,0.7-2.1c0.1-0.7,0.2-1.4,0.2-2.3c0-0.3,0-0.7,0-1.1c0-0.4,0-0.9,0-1.3V11.8 c0-0.4,0-0.8,0-1.3v0c0-0.4,0-0.7,0-1.1c0-0.8-0.1-1.5-0.2-2.2c-0.1-0.8-0.3-1.4-0.7-2.1c-0.3-0.7-0.8-1.2-1.3-1.7 c-0.5-0.5-1.1-0.9-1.8-1.3c-0.7-0.3-1.3-0.5-2.1-0.7c-0.8-0.1-1.7-0.2-2.3-0.2l-2.4,0H11.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.9,12.6c0,1-0.3,1.8-0.9,2.4c-0.7,0.7-1.5,1.1-2.6,1.1c-1,0-1.9-0.4-2.6-1.1c-0.7-0.7-1.1-1.6-1.1-2.6 c0-1.1,0.4-1.9,1.1-2.6c0.7-0.7,1.6-1.1,2.6-1.1c0.5,0,1,0.1,1.5,0.3c0.5,0.2,0.8,0.5,1.1,0.8l-0.6,0.6c-0.5-0.6-1.1-0.8-1.9-0.8 c-0.7,0-1.4,0.3-1.9,0.8c-0.5,0.5-0.8,1.2-0.8,2.1s0.3,1.5,0.8,2.1c0.5,0.5,1.2,0.8,1.9,0.8c0.8,0,1.5-0.3,2-0.8 c0.3-0.3,0.5-0.8,0.6-1.4h-2.6V12h3.4C55.9,12.2,55.9,12.4,55.9,12.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.4,9.6h-3.2v2.3H61v0.9h-2.9V15h3.2v0.9h-4.2V8.7h4.2V9.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.2,15.9h-0.9V9.6h-2V8.7h4.9v0.9h-2V15.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.8,15.9V8.7h0.9v7.1H70.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.7,15.9h-0.9V9.6h-2V8.7h4.9v0.9h-2V15.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87,14.9c-0.7,0.7-1.6,1.1-2.6,1.1c-1,0-1.9-0.4-2.6-1.1c-0.7-0.7-1-1.6-1-2.6s0.3-1.9,1-2.6 c0.7-0.7,1.6-1.1,2.6-1.1c1,0,1.9,0.4,2.6,1.1c0.7,0.7,1.1,1.6,1.1,2.6C88,13.3,87.7,14.2,87,14.9z M82.4,14.3 c0.5,0.5,1.2,0.8,1.9,0.8s1.4-0.3,1.9-0.8c0.5-0.5,0.8-1.2,0.8-2s-0.3-1.5-0.8-2c-0.5-0.5-1.2-0.8-1.9-0.8s-1.4,0.3-1.9,0.8 c-0.5,0.5-0.8,1.2-0.8,2S81.9,13.8,82.4,14.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.3,15.9V8.7h1.1l3.5,5.5h0l0-1.4V8.7h0.9v7.1h-1L90.2,10h0l0,1.4v4.4H89.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.5,26.2c-2.8,0-5.1,2.1-5.1,5c0,2.9,2.3,5,5.1,5c2.8,0,5.1-2.1,5.1-5C85.5,28.4,83.3,26.2,80.5,26.2z  M80.5,34.3c-1.5,0-2.8-1.3-2.8-3.1c0-1.8,1.3-3.1,2.8-3.1s2.8,1.2,2.8,3.1C83.3,33.1,82,34.3,80.5,34.3z M69.4,26.2 c-2.8,0-5.1,2.1-5.1,5c0,2.9,2.3,5,5.1,5c2.8,0,5.1-2.1,5.1-5C74.5,28.4,72.2,26.2,69.4,26.2z M69.4,34.3c-1.5,0-2.8-1.3-2.8-3.1 c0-1.8,1.3-3.1,2.8-3.1c1.5,0,2.8,1.2,2.8,3.1C72.3,33.1,71,34.3,69.4,34.3z M56.3,27.8v2.1h5.1c-0.2,1.2-0.6,2.1-1.2,2.7 c-0.7,0.7-1.9,1.6-4,1.6c-3.2,0-5.6-2.5-5.6-5.7s2.5-5.7,5.6-5.7c1.7,0,2.9,0.7,3.9,1.5l1.5-1.5c-1.3-1.2-3-2.2-5.4-2.2 c-4.3,0-8,3.5-8,7.8c0,4.3,3.6,7.8,8,7.8c2.3,0,4.1-0.8,5.5-2.2c1.4-1.4,1.9-3.4,1.9-5c0-0.5,0-1-0.1-1.3H56.3z M110,29.4 c-0.4-1.1-1.7-3.2-4.3-3.2c-2.6,0-4.8,2-4.8,5c0,2.8,2.1,5,5,5c2.3,0,3.7-1.4,4.2-2.2l-1.7-1.1c-0.6,0.8-1.4,1.4-2.5,1.4 c-1.1,0-1.9-0.5-2.4-1.5l6.7-2.8L110,29.4z M103.2,31.1c-0.1-1.9,1.5-2.9,2.6-2.9c0.9,0,1.6,0.4,1.9,1.1L103.2,31.1z M97.7,36h2.2 V21.2h-2.2V36z M94,27.4L94,27.4c-0.6-0.6-1.5-1.1-2.7-1.1c-2.5,0-4.8,2.2-4.8,5.1c0,2.8,2.3,5,4.8,5c1.2,0,2.2-0.5,2.7-1.1H94v0.7 c0,1.9-1,3-2.7,3c-1.4,0-2.2-1-2.5-1.8l-1.9,0.8c0.6,1.3,2,3,4.5,3c2.6,0,4.8-1.5,4.8-5.3v-9.1H94V27.4z M91.5,34.3 c-1.5,0-2.8-1.3-2.8-3c0-1.8,1.3-3.1,2.8-3.1c1.5,0,2.7,1.3,2.7,3.1C94.2,33.1,93,34.3,91.5,34.3z M120.4,21.2h-5.3V36h2.2v-5.6h3.1 c2.5,0,4.9-1.8,4.9-4.6S122.9,21.2,120.4,21.2z M120.5,28.3h-3.1v-5.1h3.1c1.7,0,2.6,1.4,2.6,2.5C123.1,26.9,122.1,28.3,120.5,28.3z  M134.2,26.2c-1.6,0-3.3,0.7-3.9,2.3l2,0.8c0.4-0.8,1.2-1.1,2-1.1c1.1,0,2.3,0.7,2.3,1.9v0.2c-0.4-0.2-1.3-0.6-2.3-0.6 c-2.1,0-4.3,1.2-4.3,3.3c0,2,1.7,3.3,3.7,3.3c1.5,0,2.3-0.7,2.8-1.4h0.1V36h2.1v-5.7C138.7,27.7,136.7,26.2,134.2,26.2z M133.9,34.3 c-0.7,0-1.7-0.4-1.7-1.3c0-1.1,1.3-1.6,2.3-1.6c1,0,1.4,0.2,2,0.5C136.3,33.4,135.2,34.3,133.9,34.3z M146.4,26.5l-2.5,6.4h-0.1 l-2.6-6.4h-2.4l3.9,9l-2.3,5h2.3l6.1-14H146.4z M126.5,36h2.2V21.2h-2.2V36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.5104,
    y1: 38.4381,
    x2: 5.6024,
    y2: 18.53,
    gradientTransform: "matrix(1 0 0 -1 0 49.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4695D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    style: {
      stopColor: "#4596D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#3EB7EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#4BC0ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#5BC2E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#60C3E4"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12,9.4c-0.3,0.4-0.5,0.9-0.5,1.7v26.2c0,0.7,0.2,1.3,0.5,1.7l0.1,0.1l14.7-14.7v-0.2V24L12,9.4L12,9.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.7864,
    y1: 25.0433,
    x2: 11.083,
    y2: 25.0433,
    gradientTransform: "matrix(1 0 0 -1 0 49.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDF10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FABB13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F6A31A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5991D"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.7,29.2l-4.9-4.9v-0.2V24l4.9-4.9l0.1,0.1l5.8,3.3c1.7,0.9,1.7,2.5,0,3.4l-5.8,3.3L31.7,29.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.1014,
    y1: 22.3213,
    x2: 2.1045,
    y2: -4.6756,
    gradientTransform: "matrix(1 0 0 -1 0 49.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7424A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30C62"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M31.8,29.2l-5-5L12,38.9c0.5,0.6,1.4,0.7,2.5,0.1L31.8,29.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.307,
    y1: 48.5609,
    x2: 20.3622,
    y2: 36.5057,
    gradientTransform: "matrix(1 0 0 -1 0 49.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#309F72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2BA671"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#4FB270"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#5FB469"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#64B664"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M31.8,19.1L14.5,9.3c-1-0.6-1.9-0.5-2.5,0.1l14.8,14.8L31.8,19.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M31.7,29.1l-17.2,9.8c-1,0.5-1.8,0.5-2.4,0l0,0L12,38.9l0,0l0.1,0.1l0,0c0.6,0.5,1.4,0.5,2.4,0l17.3-9.8 L31.7,29.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M12,38.8c-0.3-0.4-0.5-0.9-0.5-1.7v0.2c0,0.7,0.2,1.3,0.5,1.7V38.8L12,38.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M37.6,25.7l-5.9,3.4l0.1,0.1l5.8-3.3c0.8-0.5,1.2-1.1,1.2-1.7l0,0C38.8,24.7,38.4,25.3,37.6,25.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M14.5,9.5l23.1,13.1c0.8,0.4,1.2,1,1.2,1.5l0,0c0-0.6-0.4-1.2-1.2-1.7L14.5,9.3c-1.7-0.9-3-0.2-3,1.7v0.2 C11.5,9.3,12.8,8.5,14.5,9.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayStore);
export default __webpack_public_path__ + "static/media/google_play_store.48f30047e7c1bede8c3f28ddd807b694.svg";
export { ForwardRef as ReactComponent };